module.exports = "\r\n\r\n.box1 {\r\n    border: 1px solid gray;\r\n    min-height: 100px;\r\n    background-color: #eaecef;\r\n}\r\n\r\n.box2 {\r\n    border: 1px solid black;\r\n    min-height: 20px;\r\n    min-width: 65px;\r\n}\r\n\r\n.box3 {    \r\n    min-height: 20px;\r\n    min-width: 60px;\r\n}\r\n\r\n.pad10 {\r\n    padding-left: 10px\r\n}\r\n\r\n.ht50 {\r\n    height: 40px;\r\n}\r\n\r\n.shipitem {\r\n    border: 1px solid black;\r\n    padding: 10px;\r\n}\r\n\r\n.padleft20 {\r\n    padding-left: 20px\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/create-address/create-address.component.css
// module id = ./src/app/create-address/create-address.component.css
// module chunks = main